import { combineActions, handleActions } from 'redux-actions';
import { businessUnit as actions } from '../../../actions';

const initialState = {
  details: {},
};

const businessUnit = handleActions<any, any>({
  [combineActions(
    actions.setBusinessUnitDetails,
  ) as any]: (state: any, action: any): any => ({
    ...state,
    ...action.payload,
  }),
}, initialState);

export default businessUnit;
